<i class="p-sortable-column-icon fa " [ngClass]="{
    'fa-sort-up': sortOrder == 1,
    'fa-sort-down': sortOrder === -1,
    'fa-sort': sortOrder === 0
}"></i>
